import { css } from 'styled-components';
import token from 'styled-token';
import { buttonResetMixin } from '../buttonResetMixin';
import { disabledMixin } from '../disabledMixin';
import { focusMixin } from '../focusMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class TextButtonMixin */
/** @method */
export var TextButtonMixin = function TextButtonMixin(props) {
  var buttonType = props.buttonType,
    fontType = props.fontType,
    inverse = props.inverse;
  var variant = inverse ? 'Inverse' : buttonType.charAt(0).toUpperCase() + buttonType.slice(1);
  return token("TextButton.fontColor" + variant, function (color) {
    return css(["", " display:inline-flex;align-items:center;justify-content:center;&,&:active{color:", ";text-decoration:", ";}", ";", " ", " ", " ", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), color, inverse ? 'underline' : 'none', hoverMediaQueryMixin("\n                text-decoration: underline;\n            "), focusMixin(props), buttonResetMixin(props), disabledMixin(props), spacingMixin(props));
  })(props);
};